import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostBinding,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { DetectDevicesService } from '@fi-shared/fi-shared-services';

@Component({
    selector: 'fi-contact-support-section-header',
    template: `
        @if (isBackButtonShown) {
          <button mat-icon-button class="section-back-button" (click)="goBack()">
            <mat-icon class="fas fa-arrow-left"></mat-icon>
          </button>
        }
        
        <div class="section-header-text-container">
          <p class="section-header-text-header bold">{{ sectionHeaderText }}</p>
          @if (sectionDescriptionText) {
            <p class="section-header-text-subheader">{{ sectionDescriptionText }}</p>
          }
        </div>
        
        <button mat-icon-button class="section-header-button" (click)="closeDialog()">
          <mat-icon class="fas fa-times"></mat-icon>
        </button>
        `,
    styleUrls: ['./fi-contact-support-section-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-contact-support-section-header' },
    standalone: false,
})
export class FiContactSupportSectionHeaderComponent {
    @Input() sectionHeaderText: string;
    @Input() sectionDescriptionText: string;
    @Input() isBackButtonShown: boolean = false;
    @Output() onCloseDialog = new EventEmitter<void>();
    @Output() onGoBack = new EventEmitter<void>();
    @HostBinding('class.mobile') get isMobilePhone(): boolean {
        return this.detectDevicesService.isMobilePhone();
    }

    constructor(private detectDevicesService: DetectDevicesService) {}

    closeDialog() {
        this.onCloseDialog.emit();
    }

    goBack() {
        this.onGoBack.emit();
    }
}
